import React , { useRef , useState , useCallback , useMemo , useEffect } from "react";
import Modal , { ModalBody , ModalFooter } from "Components/Modal";
import { SearchInput , Table } from "Components/uiControls";
import { Button } from "Components";
import { Grid , Typography , Tooltip } from "@mui/material";
import { useSelector , useDispatch } from "react-redux";
import { useRealtimeUnits } from 'Core/hooks';
import { useIntl } from "react-intl";
import './sidePanelUnitsList.scss';

// Function to get table columns configuration
const getColumns = ( messages ) => [
  {
    key : 'label' ,
    show : true ,
    sort : true ,
    title : `${ messages['dashboardPanel_vehicles'] }` ,
    sortValue : ( item ) => item?.label ,
    export : false ,
    render : ( item ) => (
       <Grid item xs zeroMinWidth style={ { display : 'flex' , justifyContent : 'flex-start' , alignItems : 'center' , width : '95%' } }>
        <Tooltip title={ item?.label } placement="bottom">
          <Typography noWrap>{ item?.label }</Typography>
        </Tooltip>
      </Grid>
    )
  }
];

export const SidePanelUnitsList = ( { titleHeader , showPanel , unitIds , total, onClosePanel, parameterToSearch = null, valueToSearch, messageNoData = "" } ) => {
  const tableRef = useRef();
  const [ searchText , setSearchText ] = useState( '' );
  const units = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });
  const loadingUnits = useSelector( state => state.catalogsRedux.loadingUnitsList );
  const dispatch = useDispatch();
  const [ filteredUnits , setFilteredUnits ] = useState( [] );
  const { messages } = useIntl();
  
  
  // Update filtered units list when units or loading state changes
  useEffect( () => {
    if ( loadingUnits ) return;
    
    if( parameterToSearch ){
        unitIds = units.filter( unit => unit[parameterToSearch] == valueToSearch );
      setFilteredUnits( unitIds );
    }else{
      setFilteredUnits( unitIds.map( id => units.find( unit => unit.id === id ) ) );
    }
    
  } , [ loadingUnits, units, showPanel ] );
  
  // Handle panel close action
  const handleCancel = useCallback( () => {
    tableRef.current.setPage( 1 );
    tableRef.current.setSelectedItems( [] );
    onClosePanel( { open : false , data : [] } );
    setSearchText( '' );
  } , [ onClosePanel ] );
  
  // Memoize columns configuration
  const columns = useMemo( () => getColumns( messages ) , [ messages ] );
  
  // Handle search text change
  const handleSearchTextChange = useCallback( ( searchText ) => {
    setSearchText( searchText );
    tableRef.current.setPage( 1 );
    tableRef.current.setSelectedItems( [] );
  } , [] );
  
  return (
    <Modal
      title={ titleHeader }
      open={ showPanel }
      handleClose={ handleCancel }
      size="extra-small"
      position="right"
      useCloseButtonTop
      hiddenCloseButton
      className="sidePanelUnitsList"
    >
      <ModalBody className="modal-body">
        <div className="modal-search-report-list-filter">
          <SearchInput
            placeholder={ messages['search'] }
            searchText={ searchText }
            onSearchText={ handleSearchTextChange }
          />
        </div>
        <div className="modal-div-report-list-filter">
          <Table
            ref={ tableRef }
            data={ filteredUnits}
            order={ 'asc' }
            loading={ loadingUnits }
            keyColumn="id"
            topheight={300}
            columns={columns}
            searchText={searchText}
            valuesPerPage={[]}
            fixHeader
            className="modal-table-report-list-filter"
            hideDragable
            disableItemSelection
            hidePerPage
            hideTotal
            hideAllInPagination
            selectAllRows={ total }
            messageNoData={ messageNoData }
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className='btn-blue' onClick={ handleCancel }>
          { messages['close'] }
        </Button>
      </ModalFooter>
    </Modal>
  );
};
